import { mediaData } from '@/mocks/homeData';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="mb-8 md:mb-10">
          <span className="text-xs font-semibold text-primary-500 uppercase tracking-wider">🎬 MEDIA</span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mt-2">漫漫视频</h2>
          <p className="text-sm text-foreground-500 mt-1">漫评、推荐、资讯视频，换个方式看漫画</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {mediaData.map((item, idx) => (
            <a
              key={idx}
              href="#"
              className="group bg-background-100 rounded-2xl overflow-hidden cursor-pointer no-underline block hover:bg-background-200/60 transition-colors duration-200"
            >
              <div className="relative aspect-video overflow-hidden bg-background-200">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-black/10 group-hover:bg-black/20 transition-colors duration-200 flex items-center justify-center">
                  <div className="w-14 h-14 flex items-center justify-center rounded-full bg-background-50/90 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-200">
                    <i className="ri-play-fill text-2xl ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-3 right-3 px-2 py-1 text-[11px] font-medium bg-black/60 text-background-50 rounded-md">
                  {item.duration}
                </span>
              </div>
              <div className="p-5">
                <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors mb-2 line-clamp-2">{item.title}</h3>
                <div className="flex items-center gap-3 text-xs text-foreground-400">
                  <span><i className="ri-eye-line mr-1"></i>{item.views} 播放</span>
                  <span><i className="ri-time-line mr-1"></i>{item.duration}</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}